const categoryFiles = {
    Popular: 'popular', SLOTS: 'slots', MINI: 'mini', BINGO: 'bingo', RNG: 'blockchain', LIVE: 'live', FISH: 'fishing', POKER: 'cards', SPORT: 'sports', Providers: 'providers', Recent: 'recent', Favoritos: 'favorites'
}

export function categoryIcon(category, active = false) {
    const key = categoryFiles[category.id] || categoryFiles[category.gameCategoryType]
    if (key) return require('@/assets/mobile-home/categories/' + key + '.png')
    return (active ? category.activationImg : category.unActivationImg) || category.activationImg || category.unActivationImg || fallbackCategoryIcon
}

export const fallbackCategoryIcon = require('@/assets/mobile-home/categories/providers.png')
export const controlIcon = key => require('@/assets/mobile-home/ui/' + key + '.svg')
export const activityIcon = key => require('@/assets/mobile-home/activities/' + key + '.svg')

export function activityRole(activity) {
    if (activity.eventType === 'pinduoduo') return 'group'
    if (activity.eventType === 'reliefMoney') return 'support'
    if (['vipSignIn', 'signIn'].includes(activity.eventType)) return 'checkin'
    if (activity.eventType === 'weeklySalary' || (activity.eventType === 'custom' && /salario|salário|salary|зарплат/i.test(activity.eventName || ''))) return 'salary'
    return null
}

export function plainText(value) {
    const element = document.createElement('div')
    element.innerHTML = String(value || '').replace(/<br\s*\/?\s*>/gi, '\n')
    return element.textContent.trim()
}
